import React, { Fragment, useState } from "react"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"

import FloatLabelInput from "../../../../shared/components/ModernFloatLabelInput/index"
import Typograph from "../../../Typograph/index"
import Button from "shared/components/Button/Button"

import styles from "./styles.css"

import { isValidEmail } from "services/utils/validation"
import {
  INVOICE_CANCEL_MODAL_BUTTON,
  INVOICE_CONFIRM_MODAL_BUTTON
} from "shared/constants/idsElements"
import { sendGtmEventFormSubmit } from "services/utils/sendGtm"

const validationInputEmail = (value) => {
  const isEmailValid = isValidEmail(value)
  if (!value) {
    return "Campo Obrigatório"
  }
  if (isEmailValid) {
    return isEmailValid
  }
  return ""
}

const EmailModalForm = ({ t, onSubmit, email: customerEmail, onCancel }) => {
  const [email, setEmail] = useState(customerEmail)

  const [messageError, setMessageError] = useState("")

  const handleChange = (event) => {
    const currentValue = event.target.value
    setEmail(currentValue)

    setMessageError(validationInputEmail(currentValue))
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    const msgErro = validationInputEmail(email)

    if (msgErro !== "") {
      setMessageError(msgErro)
      return
    }

    sendGtmEventFormSubmit("Enviar e-mail")
    onSubmit(email)
  }

  return (
    <Fragment>
      <Typograph htmlTag="h1" size="medium">
        {t("MSG_0045")}
      </Typograph>
      <form onSubmit={handleSubmit} className={styles.form}>
        <fieldset>
          <FloatLabelInput
            id="email"
            label="Digite seu e-mail"
            name="email"
            value={email}
            onChange={handleChange}
            error={messageError}
          />
          <div className={styles.buttonsContainer}>
            <Button
              buttonStyle="secondary"
              width="small"
              onClick={onCancel}
              id={INVOICE_CANCEL_MODAL_BUTTON}
            >
              {t("MSG_0056")}
            </Button>

            <Button
              width="small"
              type="submit"
              buttonStyle="primary"
              id={INVOICE_CONFIRM_MODAL_BUTTON}
            >
              {t("MSG_0141")}
            </Button>
          </div>
        </fieldset>
      </form>
    </Fragment>
  )
}

EmailModalForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  email: PropTypes.string,
  t: PropTypes.func,
  onCancel: PropTypes.func
}

const mapStateToProps = ({ customer }, props) => ({
  initialValues: {
    email: props.email || (customer.data && customer.data.email)
  }
})

const enhance = compose(translate(), connect(mapStateToProps))

export default enhance(EmailModalForm)



// WEBPACK FOOTER //
// ./src/components/ModernEmailModal/components/EmailModalForm/index.js